<script>
  import { Link } from "svelte-navigator";
  import {
    ArrowRightIcon,
    InstagramIcon,
    LinkedinIcon,
    GlobeIcon,
  } from "svelte-feather-icons";
  import LinksLayout from "./layouts/LinksLayout.svelte";
</script>

<LinksLayout>
  <div class="app-content content" slot="content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row" />
      <div class="content-body">
        <div class="auth-wrapper auth-basic px-2">
          <div class="auth-inner my-2">
            <!-- Login basic -->
            <div class="card mb-0">
              <div class="card-body">
                <a class="brand-logo" href="https://hunayn.tech">
                  <img
                    class="logo-brand-v"
                    src="/assets/images/hunayn-vertical-logo.png"
                  />
                </a>
                <p class="text-center mb-2">
                  <span style="font-size: medium;"
                    >We're Building Digital Ecosystems</span
                  >
                </p>
                <div class="mb-1 d-grid">
                  <Link
                    to="/"
                    type="button"
                    class="btn btn-lg btn-link btn-hunayn"
                  >
                    <span>Continue To Site</span>
                    <ArrowRightIcon class="font-medium-4" />
                  </Link>
                </div>
                <div class="mb-1 d-grid">
                  <a
                    href="https://instagram.com/hunayn.tech"
                    type="button"
                    class="btn btn-lg btn-link btn-instagram-alt"
                  >
                    <InstagramIcon class="font-medium-4" />
                    <span>Instagram</span>
                  </a>
                </div>
                <div class="mb-1 d-grid">
                  <a
                    href="https://wa.me/6285171571570"
                    type="button"
                    class="btn btn-lg btn-link btn-whatsapp"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#FFFFFF"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      class="font-medium-4"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"
                      />
                    </svg>
                    <span>WhatsApp</span>
                  </a>
                </div>
                <div class="mb-1 d-grid">
                  <a
                    href="https://linkedin.com/company/hunayn"
                    type="button"
                    class="btn btn-lg btn-link btn-linkedin"
                  >
                    <LinkedinIcon class="font-medium-4" />
                    <span>LinkedIn</span>
                  </a>
                </div>

                <p class="text-center mt-1">
                  <span style="font-size: small;"
                    >For business inquiries, please contact us at <a
                      href="mailto:admin@hunayn.tech">admin@hunayn.tech</a
                    ></span
                  >
                </p>
                <div class="divider my-2">
                  <div class="divider-text">other links</div>
                </div>

                <div class="auth-footer-btn d-flex justify-content-center">
                  <a
                    href="https://fb.me/hunayn.tech"
                    class="btn btn-facebook waves-effect waves-float waves-light"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-facebook"
                      ><path
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                      /></svg
                    >
                  </a>
                  <a
                    href="https://hunayn.tech"
                    class="btn btn-foursquare white waves-effect waves-float waves-light"
                  >
                    <GlobeIcon />
                  </a>
                  <a
                    href="mailto:admin@hunayn.tech"
                    class="btn btn-google waves-effect waves-float waves-light"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-mail"
                      ><path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      /><polyline points="22,6 12,13 2,6" /></svg
                    >
                  </a>
                  <a
                    href="https://github.com/hunayntech"
                    class="btn btn-github waves-effect waves-float waves-light"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-github"
                      ><path
                        d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                      /></svg
                    >
                  </a>
                </div>
              </div>
            </div>
            <!-- /Login basic -->
          </div>
        </div>
      </div>
    </div>
  </div>
</LinksLayout>
